/**
 * shc-gallery-fix.js  —  Midnight Gents
 * ------------------------------------------------------------------
 * Fix: on this store's customized product page (SHC layout), Horizon's
 * native <media-gallery> fails to attach its `shopify:product:select`
 * listener at connect time, so choosing a colour swatch DOES change the
 * variant (price / add-to-cart follow) but the product IMAGE never swaps.
 * To the shopper it looks like the colour picker is dead.
 *
 * This adds a resilient, document-level listener that performs exactly the
 * same media-gallery replacement Horizon's media-gallery.js would do
 * (verified working on midnightgents.shop, 2026-09-20). It is additive and
 * idempotent, so it is harmless if the native handler ever does fire.
 * ------------------------------------------------------------------
 */
(function () {
  if (window.__shcGalleryFix) return;
  window.__shcGalleryFix = true;

  function firstImgFile(gallery) {
    if (!gallery) return '';
    var img = gallery.querySelector('img');
    if (!img) return '';
    var src = img.getAttribute('src') || img.currentSrc || img.src || '';
    return src.split('/').pop().split('?')[0];
  }

  function onProductSelect(event) {
    var picker = event.target;
    if (!(picker instanceof Element)) return;
    if (picker.closest('product-card') || picker.closest('quick-add-dialog')) return;

    var section = picker.closest('.shopify-section, dialog');
    if (!section || !event.promise) return;

    event.promise
      .then(function (result) {
        var detail = result && result.detail;
        if (!detail || !detail.html) return;

        var newGallery = detail.html.querySelector('media-gallery');
        if (!newGallery) return;

        var currentGallery = section.querySelector('media-gallery');
        if (!currentGallery) return;

        if (firstImgFile(currentGallery) === firstImgFile(newGallery)) return;

        currentGallery.replaceWith(newGallery);
      })
      .catch(function () {});
  }

  document.addEventListener('shopify:product:select', onProductSelect);
})();